import type { Styles } from '@adornis/ass/style.js';
import { getExtensionForData } from '@adornis/buildify/client/globals/methods.js';
import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import { XBuildifyVisualization } from '@adornis/buildify/client/x-buildify-visualization.js';
import type { Base } from '@adornis/buildify/db/Base.js';
import { BaseContainer } from '@adornis/buildify/db/extensions/BaseContainer.js';
import { DubniumBaseContainerFlexWithBackground } from '@adornis/digitale-helden-shared/db/buildify/container/DubniumBaseContainerFlexWithBackground.js';
import { nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('d-buildify-visualization')
export class DBuildifyVisualization extends XBuildifyVisualization {
  protected override item({
    entity,
    extensions,
    dropzoneBefore,
    dropzoneAfter,
  }: {
    entity: Base;
    extensions: BuildifyExtension[];
    dropzoneBefore: boolean;
    dropzoneAfter: boolean;
  }) {
    const extension = getExtensionForData(entity, extensions);
    if (!extension) return nothing;
    const isContainer = entity instanceof BaseContainer;
    const isContainerWithBackground = entity instanceof DubniumBaseContainerFlexWithBackground;

    if (isContainer && extension.defaultValues && !extension.defaultValues.margin)
      extension.defaultValues.margin = (instance: Base) => {
        if (instance.parentID) return {};
        return { global: '0 0 96px 0' };
      };

    if (isContainerWithBackground && extension.defaultValues && !extension.defaultValues.padding)
      extension.defaultValues.padding = (instance: Base) => {
        if (instance.parentID) return {};
        return { global: '48px' };
      };

    return extension.render(entity, {
      isSubelement: false,
      dropzoneBefore,
      dropzoneAfter,
    });
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {},
      },
    ] as Styles[];
  }
}
